import type { ComponentProps } from 'react';
import { Price } from '../Price/Price';
import { cn } from '../../utils/cn';
import { useCreditCard } from './CreditCard';
import clsx from 'clsx';

type CreditCardBalanceProps = ComponentProps<typeof Price> & {
  className?: string;
}

export const CreditCardBalance = ( { className, children, currency }: CreditCardBalanceProps ) => {
  const creditCard = useCreditCard();

  return (
    <div className={ cn( clsx(
      'tabular-nums [text-shadow:_0_2px_4px_rgba(0,0,0,0.5)] text-white',
      {
        'text-lg': creditCard.size === 'default',
        'text-sm': creditCard.size === 'sm'
      }
    ), className ) }>
      <Price currency={ currency }>
        {children}
      </Price>
    </div>
  )
}
CreditCardBalance.displayName = 'CreditCardBalance';
